<template>
  <div class="body_right">
    <div class="body_right_first">
      <div class="top_img"><img src="https://www.rakulink.com/zhongqiu.png"/></div>
      <div class="friends_titbj">
        <div class="user_img"><img :src="userInfo.avatar"/></div>
        <div class="user_name">{{userInfo.nickname}}<div class="gender male" v-if="this.$store.state.userInfo.gender==1"><i class="el-icon-male"></i></div><div class="gender female" v-if="this.$store.state.userInfo.gender==0"><i class="el-icon-female"></i></div></div>
        <div class="user_msg">简介：{{userInfo.sign}}</div>
        <div class="user_ip">IP 深圳</div>
        <div class="user_menu">
          <div class="item">
            <div class="title">二ユース</div>
            <div class="msg">{{num.charmNum}}</div>
          </div>
          <div class="item">
            <div class="title">人気度</div>
            <div class="msg">{{num.trackCount}}</div>
          </div>
          <div class="item">
            <div class="title">フォロー中/关注</div>
            <div class="msg">{{num.followNum}}</div>
          </div>
          <div class="item">
            <div class="title">フォロワー/粉丝</div>
            <div class="msg">{{num.followerNum}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="body_right_second">
      <div class="img"><img src="../../../assets/imgs/icon_open.png"></div>
      <div class="title">我的資料</div>
    </div>
    <div class="body_right_third">
      <div class="body_right_third_item">
        <div class="item_left">昵称：</div>
        <div class="item_right name">
          <el-input v-model="name" @blur="updateInfo()"></el-input>
        </div>
      </div>
      <div class="body_right_third_item">
        <div class="item_left">性别：</div>
        <div class="item_right">
          <el-radio v-model="sex" label="1" @change="updateInfo()">男性</el-radio>
          <el-radio v-model="sex" label="0" @change="updateInfo()">女性</el-radio>
          <el-radio v-model="sex" label="2" @change="updateInfo()">非表示</el-radio>
        </div>
      </div>
      <div class="body_right_third_item">
        <div class="item_left">概要：</div>
        <div class="item_right">
          <el-input v-model="sign" @blur="updateInfo()"></el-input>
        </div>
      </div>
      <!-- <div class="body_right_third_item">
        <div class="item_left">エリア：</div>
        <div class="item_right">
          <div class="select">
            <el-select v-model="country" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="select">
            <el-select v-model="city" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div> -->
      <!-- <div class="body_right_third_item">
        <div class="item_left">パスワード:</div>
        <div class="item_right">
          <el-input placeholder="请输入内容" type="password" v-model="password" class="input-with-select">
            <el-button slot="append">更改</el-button>
          </el-input>
        </div>
      </div> -->
      <!-- <div class="body_right_third_item">
        <div class="item_left">Email:</div>
        <div class="item_right">
          <el-input placeholder="请输入内容" v-model="email" class="input-with-select">
            <el-button slot="append">更改</el-button>
          </el-input>
        </div>
      </div> -->
      <!-- <div class="body_right_third_item">
        <div class="item_left">設定友だちに紹介:</div>
        <div class="item_right">
          <div class="right_img"><img src="@/assets/imgs/my_wechat.png"/></div>
          <div class="right_img"><img src="@/assets/imgs/my_facebook.png"/></div>
          <div class="right_img"><img src="@/assets/imgs/my_twitter.png"/></div>
        </div>
      </div> -->
      <div class="body_right_third_btn" @click="logOut()">注销</div>
    </div>
  </div>
</template>

<script>
  import * as json from '@/assets/js/json'
  export default {
    components: {
    },
    props:['num'],
    data () {
      return {
        name: '邦人NAVA',
        sex: '1',
        sign: '',
        password: '',
        email: '',
        userInfo: null,
      }
    },
    created () {
      this.userInfo = this.$store.state.userInfo
      this.name = this.userInfo.nickname,
      this.sex = this.userInfo.gender+""
      this.sign = this.userInfo.sign
    },
    methods: {
      updateInfo(){
        let Option = {
          nickname : this.name,
          gender : this.sex,
          sign : this.sign
        }
        json.post('/api/member/profile/update_tiny_info', Option).then((res) => {
          if (res.data.success) {
            this.$notify({
              message: '修改成功',
              type: 'success'
            });
            this.userInfo.nickname = Option.nickname
            this.userInfo.gender = Option.sex
            this.userInfo.sign = Option.sign
            this.$store.commit('set_user_info',this.userInfo)
            this.$parent.fetch()
          }
        })
      }, 
      logOut(){
        json.post('/api/member/profile/logout', null).then((res) => {
          if (res.data.success) {
            this.$store.commit('set_user_info',{})
            this.$store.commit('set_token','')
            window.localStorage.clear()
            this.$notify({
              message: 'ログアウトしました',
              type: 'success'
            });
            this.$socket.close()
            this.$router.push('/index')
          }
        })
      },
      IsEmail(str) {
          var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
        return  reg.test(str);
      }
    }
  }
</script>

<style src="@/pages/homePage/home/index.css" scoped>
</style>
